<template>
  <div class="index-container">
    <coverImage/>
    <!-- 倒计时 -->
    <div class="count-down" v-show="leftTime > 0">
      <div class="count-text">
        {{ countText }}
      </div>
      <div class="count-time" v-for="(item, index) in timeInfo" :key="index">
        <div class="count-time__box">
          {{ item.value }}
        </div>
        <div class="count-time__text">
          {{ item.label }}
        </div>
      </div>
    </div>

    <component
      v-for="(item, index) in Object.keys(moduleData)"
      :key="index"
      v-bind:is="`${item.split('_')[0]}-index`"
      :moduleInfo="moduleData[item]"
      :moduleFlag="item"
    />
  </div>
</template>

<script>
  import {sendLog} from '@/api/pc/common'
  import {resolveRecommendData} from '@/utils/recommend'
  import {isProd, isLogin} from '@/utils/index'

  import coverImage from '@/components/pc/cover'

  import news from '@/components/pc/news'
  import introduction from '@/components/pc/introduction'
  import schedule from '@/components/pc/schedule'
  import live from '@/components/pc/live'
  import guest from '@/components/pc/guest'
  import booth from '@/components/pc/booth'
  import activity from '@/components/pc/activity'
  import partner from '@/components/pc/partner'
  import enterprise from '@/components/pc/enterprise';
  import credit from '@/components/pc/credit';
  import cases from '@/components/pc/cases';

  export default {
    components: {
      coverImage,
      'news-index': news,
      'introduction-index': introduction,
      'schedule-index': schedule,
      'live-index': live,
      'guest-index': guest,
      'booth-index': booth,
      'activity-index': activity,
      'partner-index': partner,
      'enterprise-index': enterprise,
      'credit-index': credit,
      'cases-index': cases
    },
    data() {
      return {
        moduleData: resolveRecommendData(this._modules, this._moduleInfo, 'pc'),
        timeInfo: [
          {
            label: 'DAYS',
            value: ''
          },
          {
            label: 'HOURS',
            value: ''
          },
          {
            label: 'MINUTES',
            value: ''
          },
          {
            label: 'SECONDS',
            value: ''
          }
        ],
        leftTime: '',
        countText: '距离会议开始还有',
      }
    },
    methods: {
      leftTimer() {
        let timeInfo = this.timeInfo

        let days = parseInt(this.leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数 
        let hours = parseInt(this.leftTime / 1000 / 60 / 60 % 24, 10); //计算剩余的小时 
        let minutes = parseInt(this.leftTime / 1000 / 60 % 60, 10); //计算剩余的分钟 
        let seconds = parseInt(this.leftTime / 1000 % 60, 10); //计算剩余的秒数 
        timeInfo[0].value = this.checkTime(days);
        timeInfo[1].value = this.checkTime(hours);
        timeInfo[2].value = this.checkTime(minutes);
        timeInfo[3].value = this.checkTime(seconds);
        if (this.leftTime <= 0) {
          return;
        }
        this.leftTime -= 1000;
        setTimeout(()=>{this.leftTimer()}, 1000);
      },
      checkTime(i) { //将0-9的数字前面加上0，例1变为01 
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      },
    },
    async created() {
      this.leftTime = this._websiteInfo.startTime?(this._websiteInfo.startTime - new Date().getTime()): -1; //计算剩余的毫秒数
      this.leftTimer();

      const websiteId = this._websiteInfo.id
      if (isProd() && isLogin() && websiteId) {
        try {
          await sendLog({
            websiteId,
            websiteModuleId: websiteId
          })
        } catch (e) {
          console.log('首页登录过期')
          console.log(e)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .count-down {
    width:100%;
    height: 182px;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    overflow: hidden;

    .count-text {
      width: 100%;
      margin-top: 24px;
      font-size: 24px;
      color: #FFFFFF;
      text-align: center;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    .count-time {
      width: 70px;
      display: inline-block;
      margin: 16px 20px 0 0;

      &:last-child {
        margin-right: 0;
      }
  
      &__box {
        height: 70px;
        display: grid;
        align-items: center;
        background: #FFFFFF;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        font-size: 28px;
        color: #1AB370;
        font-weight: 600;
      }

      &__text {
        margin-top: 5px;
        font-size: 12px;
        color: #E5E5E5;
        text-align: center;
        font-weight: 500;
      }
    }
  }
</style>
